import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import Home from '../views/home.vue'
import Pledge from '../views/pledge.vue'
import BlindboxDetail from '../views/blindbox/detail.vue'

import Page503 from '../views/503.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: 'home',
    children: [
      {
        path: 'home',
        component: Home,
        name: 'Home',
      },
      {
        path: 'pledge',
        component: Pledge,
        name: 'pledge',
      },
      {
        path: 'blindbox/:id',
        component: BlindboxDetail,
        name: 'BlindboxDetail',
      }
    ],
  },
  {
    path: '/503',
    component: Page503,
    name: '提示',
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.afterEach(() => {
  const app = document.getElementById("app");
  if (app) {
    app.scrollTop = 0;
  } else {
    window.scrollTo(0, 0);
  }
});

export default router
